import styled from 'styled-components';
import { Row } from 'react-flexbox-grid';

import { mediaQueries } from '../../../../utils/styles';
import Icon from '../../../common/components/Icon';

export const Wrapper = styled(Row)`
  width: 100%;
  z-index: 1000;
  color: #363636;
  padding: 16px 0;
  box-sizing: border-box;
  height: 96px;
  text-align: left;
  &.hover:hover {
    cursor: pointer;
    background-color: ${({ noHover }) => (noHover ? 'transparent' : 'rgba(227, 236, 243, 0.4)')};
  }
`;

export const Status = styled.p`
  margin: 0 0 5px 0;
  font-family: 'RobotoCondensedLight';
  font-size: 13px;
`;

export const Name = styled.p`
  cursor: pointer;
  margin: 5px 0 0 0;
  font-family: 'RobotoBold';
  letter-spacing: 0.2px;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Email = styled.p`
  margin: 1px 0 2px;
  font-size: 15px;
  letter-spacing: 0.2px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledIcon = styled(Icon)`
  display: inline-block;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
  margin: 9px 0 0 11px;
`;

export const StyledIconX = styled(Icon)`
  cursor: pointer;
  display: block;
  padding: 0;
  margin: 0 0 0 5px;
  box-sizing: border-box;
  &:hover path {
    fill: #d0021b;
  }
`;

export const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 32px;
  background-color: #d8dee4;

  ${mediaQueries.xs(`
    margin-left: 25px;
  `)};
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  ${mediaQueries.xs(`
    padding-left: 0;
  `)};
`;

export const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/AccountCard/styled-components.js